import React, { useState } from 'react'
import InputCss from '../Input.module.css'

const InputEmail = ({ label, name }) => {
    const [value, setValue] = useState('')
    const [valid, setValid] = useState(false)

    // eslint-disable-next-line
    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

    const handleChange = (evt) => {
        const text = evt.target.value;
        if (validEmailRegex.test(text)) {
            if(!valid) setValid(true)
        } else {
            if(valid) setValid(false)
        }
        setValue(text)
    }

    return (
        <div className={InputCss.input_contain}>
            <input autoComplete="off" className={valid ? `${InputCss.input_valido}` : ""} name={name} value={value} onChange={handleChange} onKeyPress={handleChange} />
            <label className={InputCss.label}>{label}</label>
        </div>
    )
}

export default InputEmail
